<template>
    <div>
        <vue-headful :title="'[Report Schedules - '+scheduleCount+'] - AMOS365'" />

        <h4 class="page-header">
            Report Schedules ({{ scheduleCount }})
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="reportsTable" url="/reports/schedules/list" :columns="columns" :options="options">
                    <template slot="id" slot-scope="props">
                        <router-link :to="`/reports/schedules/${props.row.id}`" class="btn btn-xs btn-default">
                            <i class="fa fa-list"></i> Edit
                        </router-link>
                    </template>

                    <template slot="report_name" slot-scope="props">
                        <router-link :to="`/reports/view/${props.row.report_id}`">{{ props.row.report_name }}</router-link>
                    </template>

                    <template slot="schedule_time" slot-scope="props">
                        <schedule-name :schedule="props.row" />
                    </template>

                    <template slot="user_id" slot-scope="props">
                        {{ props.row.first_name+' '+props.row.last_name }}
                    </template>

                    <template slot="child_row" slot-scope="props">
                        <div v-if="props.row.users.length > 0 || props.row.emails.length > 0">
                            <label>Recipients ({{ (props.row.users.length + props.row.emails.length) }})</label>
                            <ul>
                                <li v-for="user in props.row.users">
                                    {{ user.first_name }} {{ user.last_name }} - <a :href="`mailto:${user.email}`">{{ user.email }}</a>
                                </li>
                                <li v-for="email in props.row.emails">
                                    <a :href="`mailto:${email.email_address}`">{{ email.email_address }}</a>
                                </li>
                            </ul>
                        </div>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                scheduleCount: null,
                recipient_search: null,
                exportingTable: false,
                userTimezone: this.$root.timezone,
                columns: ['report_type', 'report_name', 'schedule_type', 'schedule_time', 'user_id'],
                options: {
                    headings: {
                        report_type: 'Report Type',
                        report_name: 'Report Name',
                        schedule_type: 'Frequency',
                        schedule_time: 'Schedule',
                        user_id: 'Created By',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'reports.report_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Report Schedules",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.scheduleCount === null)
                        {
                            //Set the count
                            this.scheduleCount = response.data.count;
                        }
                        //this.$emit('reportListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Check it
                        if(this.recipient_search)
                        {
                            data.recipient_search = this.recipient_search;
                        }

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

            canManageReports(){
                //Check Permissions
                return this.$root.hasPermission("reports.manage");
            },
        },

        methods: {
            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.reportsTable.columns));

                //Build the payload
                var payload = {
                    //filters: filters,
                    query: (this.$refs.reportsTable.getRequestParams()).query,
                    orderBy: this.$refs.reportsTable.options.orderBy.column,
                    ascending: this.$refs.reportsTable.options.orderBy.ascending,
                    table: 'reportsTable',
                    columns: cols,
                    export: true,
                };

                //Send it
                this.$http.get('/reports', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            canView(report){
                //Check if Public
                if(report.is_public == 1)
                {
                    return true;
                }

                //Check permissions
                if(this.$root.hasPermission('reports.manage.all'))
                {
                    return true;
                }

                //Check if user owns the report and has permission
                if(report.user_id == this.$store.state.user.id && this.$root.hasPermission('reports.manage.own'))
                {
                    return true;
                }

                //NOPE
                return false;
            },
        },

        mounted() {

        }
    }
</script>
